import { faker } from '@faker-js/faker';

const mockCdd = () => {
  const item = {
    id: faker.string.uuid(),
    created_at: new Date().toISOString(),
    risk_level: 'High',
    sections: [
      {
        id: 'section_a',
        title: 'A - Customer identification',
        customer: null,
      },
      {
        id: 'section_b',
        title: 'B - Customer interview statements',
        items: [
          {
            id: 'b1',
            description:
              'a) The Customer adopted and implemented internal regulations aimed at ensuring compliance with the applicable anti- bribery and corruption legislative framework',
            value: false,
          },
          {
            id: 'b2',
            description:
              'b) The Customer adopted and implemented internal regulations at ensuring compliance with the international standards and international regulations on the Countering of the Terrorism Financing',
            value: false,
          },
          {
            id: 'b3',
            description:
              'c) The Customer\'s activity complies with the restrictive measures and economic and trade sanctions adopted by the United Nations, the European Union and the USA (OFAC)',
            value: false,
          },
          {
            id: 'b4',
            description:
              'd) The Customer doesn\'t support or promote, either directly or indirectly through any governmental body or entity, activities linked to anti-personnel mines, cluster munitions and submunitions',
            value: false,
          },
          {
            id: 'b5',
            description:
              'e) The Customer declares that no legal proceeding nor formal investigations by public prosecutors are currently pending against its Beneficial Owner for a violation of anti-bribery ad anti-corruption laws and/or and/or anti-money laundering and combating terrorism financing laws',
            value: false,
          },
        ],
      },
      {
        id: 'section_c',
        title: 'C - Identification of the beneficial owner',
        items: [
          {
            id: 'c1',
            description:
              'I declare I have identified the UBO: “Beneficial owner” means any natural person(s) who ultimately owns or controls the Customer and/or the natural person(s) on whose behalf a transaction or activity is being conducted. When the Customer\'s ownership and control structure does not allow the unambiguous identification of natural persons to whom the direct or indirect ownership of the body or its control is attributable (e.g. as in the cases of public bodies and public law bodies), the beneficial owner coincides with the natural person who has the powers of legal representation, administration or management (e.g. depending on the nature of the Customer, the beneficial owner could be identified in the Ministry or the Head of the Department).',
            value: false,
          },
        ],
      },
      {
        id: 'section_d',
        title:
          'D - Declaration on the purpose and intended nature of the business relationship',
        items: [
          {
            id: 'd1',
            description:
              'Country of origin of the funds used in the relationship or operation',
            value: [],
          },
          {
            id: 'd2',
            description:
              'Country of destination of the funds involved in the operation',
            value: [],
          },
        ],
      },
    ],
  };
  return item;
};

const mockEdd = () => {
  const item = {
    id: faker.string.uuid(),
    created_at: new Date().toISOString(),
    risk_level: 'Severe',
    sections: [
      {
        id: 'section_a',
        title: 'A - Customer identification',
        customer: null,
      },
      {
        id: 'section_b',
        title: 'B - Customer interview statements',
        items: [
          {
            id: 'b1',
            description:
              'a) The Customer adopted and implemented internal regulations aimed at ensuring compliance with the applicable anti- bribery and corruption legislative framework',
            value: false,
          },
          {
            id: 'b2',
            description:
              'b) The Customer adopted and implemented internal regulations at ensuring compliance with the international standards and international regulations on the Countering of the Terrorism Financing',
            value: false,
          },
          {
            id: 'b3',
            description:
              'c) The Customer\'s activity complies with the restrictive measures and economic and trade sanctions adopted by the United Nations, the European Union and the USA (OFAC)',
            value: false,
          },
          {
            id: 'b4',
            description:
              'd) The Customer doesn\'t support or promote, either directly or indirectly through any governmental body or entity, activities linked to anti-personnel mines, cluster munitions and submunitions',
            value: false,
          },
          {
            id: 'b5',
            description:
              'e) The Customer declares that no legal proceeding nor formal investigations by public prosecutors are currently pending against its Beneficial Owner for a violation of anti-bribery ad anti-corruption laws and/or and/or anti-money laundering and combating terrorism financing laws',
            value: false,
          },
        ],
      },
      {
        id: 'section_c',
        title: 'C - Identification of the beneficial owner',
        items: [
          {
            id: 'c1',
            description:
              'Does the person belong to categories of Politically Exposed Persons (PEP)? If yes, please indicate the public role held and/or the relationship with a Politically Exposed Person and his/her role:',
            value: false,
          },
          {
            id: 'c2',
            description: 'Business relations in non-EU countries:',
            value: false,
          },
          {
            id: 'c3',
            description: 'Annual income capacity (after tax):',
            value: [],
          },
          {
            id: 'c4',
            description: 'Total personal assets (securities and real estate):',
            value: [],
          },
        ],
      },
      {
        id: 'section_d',
        title:
          'D - Declaration on the purpose and intended nature of the business relationship',
        items: [
          {
            id: 'd1',
            description:
              'Country of origin of the funds used in the relationship or operation',
            value: [],
          },
          {
            id: 'd2',
            description:
              'Country of destination of the funds involved in the operation',
            value: [],
          },
        ],
      },
    ],
  };
  return item;
};

export { mockCdd, mockEdd };
